import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { layoutApi } from 'components/layout/layoutApi';
import { Layout } from 'components/layout/model/Layout';
import { getLocalSettings } from 'components/settings/localStore';
import logger from 'lib/logger';

export interface LayoutState {
    layout?: Layout;
    error: string;
    isLoading: boolean;
    tenantId: string;
}

export const initialState: LayoutState = {
    layout: undefined,
    error: '',
    isLoading: true,
    tenantId: ''
};

export const getLayout = createAsyncThunk('layout/getLayout', async () => {
    const localSettings = getLocalSettings();
    const data = await layoutApi.getActive();
    if (!data.anchor.properties) {
        throw new Error('Cannot read properties field of undefined');
    }
    return {
        layout: data.anchor.properties,
        tenantId: localSettings?.merchantId ?? ''
    };
});

const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getLayout.pending, state => {
                state.isLoading = true;
            })
            .addCase(getLayout.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = '';
                state.layout = action.payload.layout;
                state.tenantId = action.payload.tenantId;
            })
            .addCase(getLayout.rejected, (state, action) => {
                state.isLoading = false;
                state.layout = undefined;
                state.error = action.error.message ?? '';
                logger.error(action.error);
            });
    }
});

export default layoutSlice.reducer;
